import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem("adminId");

  return isLoggedIn ? children : <Navigate to="/auth/login" replace />;
}
